import { render } from "./dtm-generator.vue?vue&type=template&id=c1dda37c"
import script from "./dtm-generator.vue?vue&type=script&lang=ts"
export * from "./dtm-generator.vue?vue&type=script&lang=ts"
script.render = render

export default script